/**
 * Dimmer device action preparations.
 * Duplicated from Scenes for Flow independence.
 */

import { convertUiPropertyToSceneCommand } from '../utilities';
import type {
	DeviceActionContext,
	PreparedDeviceAction,
	DimmerActionName,
	DimmerHandler,
} from './types';
import type { DeviceAction } from 'src/types/DeviceActionUI';

const handleTurn: DimmerHandler = (action, context, set) => {
	set[convertUiPropertyToSceneCommand('turn', context.channel)] = action.value;
};

const handleBrightness: DimmerHandler = (action, context, set) => {
	set[convertUiPropertyToSceneCommand('brightness', context.channel, 'white')] = action.value;
};

const DIMMER_ACTION_HANDLERS: Record<DimmerActionName, DimmerHandler> = {
	turn: handleTurn,
	state: handleTurn,
	brightness: handleBrightness,
	gain: handleBrightness,
	transition_duration: (action, context, set) => {
		set[convertUiPropertyToSceneCommand('transition_duration', context.channel)] = action.value;
	},
};

export const prepareDimmerAction = (context: DeviceActionContext): PreparedDeviceAction => {
	const { hexToDecimal, actions } = context;

	const action: PreparedDeviceAction = {
		_gui_purpose: 'action',
		r: 'dev:' + hexToDecimal + ':setup',
	};

	const set: Record<string, unknown> = {
		_isdata: true,
	};

	for (const actionEl of actions) {
		const handler = DIMMER_ACTION_HANDLERS[actionEl.name as DimmerActionName];
		if (handler) {
			handler(actionEl, context, set);
		}
	}

	action.set = { ...set };
	return action;
};
